export default __webpack_public_path__ + "static/media/layerRight2.33259f22.webp";